import { render, staticRenderFns } from "./ReportList.vue?vue&type=template&id=38a23cf7&scoped=true&"
import script from "./ReportList.vue?vue&type=script&lang=js&"
export * from "./ReportList.vue?vue&type=script&lang=js&"
import style0 from "./ReportList.vue?vue&type=style&index=0&id=38a23cf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.registry.npmjs.org/vue-loader/15.9.7_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a23cf7",
  null
  
)

export default component.exports